import { createContext, useContext, type ReactNode } from 'react';
import { useEnrollDeviceOnLogin, type EnrollStatus, type EnrollErrorKind } from '@/modules/auth/presentation/hooks/useEnrollDeviceOnLogin';

interface EnrollResult {
  status: string;
  errorKind: string | null;
}

export interface DeviceEnrollContextValue {
  trigger: (idInstance: number, backendTimezone: string) => Promise<void>;
  status: EnrollStatus;
  errorKind: EnrollErrorKind;
  errorDetail: string | null;
  dismiss: () => void;
  setEnrollResult: (result: EnrollResult) => void;
}

export const DeviceEnrollContext = createContext<DeviceEnrollContextValue | null>(null);

export function DeviceEnrollProvider({ children }: { children: ReactNode }) {
  const { trigger, status, errorKind, errorDetail, dismiss, setEnrollResult } = useEnrollDeviceOnLogin();

  return (
    <DeviceEnrollContext.Provider value={{ trigger, status, errorKind, errorDetail, dismiss, setEnrollResult }}>
      {children}
    </DeviceEnrollContext.Provider>
  );
}

export function useDeviceEnrollState(): DeviceEnrollContextValue {
  const ctx = useContext(DeviceEnrollContext);
  if (!ctx) throw new Error('useDeviceEnrollState must be used inside <DeviceEnrollProvider>');
  return ctx;
}
